export const STORAGE_KEY__REDIRECT_AFTER_LOGIN_URL = 'redirectAfterLogin';

export const EMAIL_TYPE__CUSTOM = 'EMAIL_TYPE__CUSTOM';
export const EMAIL_TYPE__PROFILE = 'EMAIL_TYPE__PROFILE';
